module.exports = __webpack_public_path__ + "img/app-logo.1708dd91.png";